import {
  HOST_API_BASE_URL,
  PARTNER_API_BASE_URL
} from 'services/connections.service';

const interpolatePath = ({ pathname, pathParams }) =>
  Object.entries(pathParams).reduce(
    (template, [key, value]) => template.replace(`:${key}`, value ?? ''),
    pathname
  );
const buildQueryString = ({ queryParams }) => {
  const queryString = new URLSearchParams(queryParams).toString();
  return queryString ? `?${queryString}` : '';
};

export const getURLPath = ({
  pathname,
  pathParams = {},
  queryParams = {}
}) => {
  const interpolatedPath = interpolatePath({ pathname, pathParams });
  const queryString = buildQueryString({ queryParams });
  return `${interpolatedPath}${queryString}`;
};

const getAPIURL = ({
  baseUrl,
  pathname,
  pathParams = {},
  queryParams = {}
}) => {
  const path = getURLPath({ pathname, pathParams, queryParams });
  const url = new URL(`${baseUrl}${path}`);
  return url.toString();
};

const getPartnerAPIURL = (pathname, pathParams = {}) =>
  getAPIURL({ baseUrl: PARTNER_API_BASE_URL, pathname, pathParams });

const getHostAPIURL = (pathname, pathParams = {}) =>
  getAPIURL({ baseUrl: HOST_API_BASE_URL, pathname, pathParams });

export const VERIFY_OTP_WITH_MOBILE_API_URL = getPartnerAPIURL('/login');

export const SEND_OTP_API_URL = getPartnerAPIURL('/send-otp');

export const GET_ORDER_DETAIL_API_URL = ({ partnerId, orderId }) =>
  getPartnerAPIURL('/partners/:partnerId/orders/:orderId/details', {
    partnerId,
    orderId
  });

export const GET_BID_DETAILS_BY_PARTNER_AND_REFERENCE_ID_API_URL = ({
  partnerId,
  referenceId
}) =>
  getPartnerAPIURL('/partners/:partnerId/bid-references/:referenceId', {
    partnerId,
    referenceId
  });

export const UPDATE_BID_ITEM_API_URL = (bidId, bidItemId) =>
  getPartnerAPIURL('/bid/:bidId/bid-item/:bidItemId', {
    bidId,
    bidItemId
  });

export const POST_CALLBACK_REQUEST_FOR_BID_API_URL = (bidId) =>
  getPartnerAPIURL('/bids/:bidId/request-callback', { bidId });

export const SUBMIT_BID_API_URL = (bidId) =>
  getPartnerAPIURL('/bid/:bidId', { bidId });

export const GET_PARTNER_USER_PROFILE_API_URL = () =>
  getPartnerAPIURL('/partner-users/detail');

export const CONTACT_US_FORM_API_URL = () =>
  getPartnerAPIURL('/partners/contact-us');

export const GET_PARTNER_SUMMARY_STATS_API_URL = () =>
  getPartnerAPIURL('/summary-stats');

export const SEARCHKIT_BID_LIST_API_URL = getPartnerAPIURL('/bid-list');

export const SEARCHKIT_DELIVERY_PICKUP_LIST_API_URL =
  getPartnerAPIURL('/logistics');

export const SEARCHKIT_ORDER_LIST_API_URL = getPartnerAPIURL('/order-list');

export const UPDATE_ORDER_ACKNOWLEDGEMENT_API_URL = ({ orderId }) =>
  getPartnerAPIURL('/orders/:orderId/acknowledgement', { orderId });

export const GET_PARTNER_USERS_BY_PARTNER_ORG_API_URL = ({ partnerOrgId }) =>
  getPartnerAPIURL('/partners/:partnerOrgId/partner-users', { partnerOrgId });

export const SEARCHKIT_PRODUCT_LIST_API_URL =
  getPartnerAPIURL('/product-search');

export const GET_PRODUCT_API_URL = ({ productSlug: slug }) =>
  getHostAPIURL('/products/:slug', { slug });
